/* ============================================================
   tio-quickview.js - Quick View global.

   REGLA F1 (MIGRATION 4.5): TODO boton "Agregar" de card abre el
   Quick View, en las 4 superficies, incluso con una sola variante.
   El add entra con VARIANTE EXPLICITA.

   CADENA F3 (MIGRATION 8.1), en este orden y sin excepcion:
     1. POST /cart/add.js PRIMERO
     2. feedback "¡Agregado!" SOLO con respuesta OK
     3. vuelo como DECORACION, con guard teFlySafe
   El contador usa el item_count REAL que devuelve el carrito.

   Listeners DELEGADOS en document (doctrina 8.1): el Quick View se
   inyecta y se destruye, y las cards se re-renderizan; los handlers
   por-elemento morirían con el nodo.
   ============================================================ */
(function () {
  'use strict';

  var ov = document.querySelector('[data-tio-qv-ov]');
  if (!ov) return;

  var abierto = false;
  var cargando = false;

  function bloquearScroll(si) {
    if (si) {
      var comp = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (comp > 0) document.body.style.paddingRight = comp + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  /* Cuenta las aperturas. Sirve para descartar la respuesta de un fetch que
     quedo obsoleto porque el cliente cerro mientras cargaba. */
  var turno = 0;

  /* ⚠️ 28-jul-2026 · LA TRAMPA.
     Aca habia `if (!abierto) return;`. O sea que CERRAR dependia de una
     variable interna: si `abierto` se desincronizaba del estado visible
     —pasa si el cliente toca para cerrar mientras la ficha todavia carga—
     el velo seguia puesto y NINGUNA salida respondia: ni la X, ni tocar
     fuera, ni Escape. El cliente quedaba encerrado con la tienda bloqueada.
     Ahora cerrar es incondicional e idempotente: siempre desmonta. Llamarlo
     de mas no cuesta nada; no poder llamarlo costaba la venta. */
  function cerrar() {
    turno++;                 /* invalida cualquier carga en vuelo */
    abierto = false;
    cargando = false;        /* si se cerro durante la carga, no dejar trabado el guard */
    ov.classList.remove('is-active');
    ov.setAttribute('aria-hidden', 'true');
    bloquearScroll(false);
    setTimeout(function () { if (!abierto) ov.innerHTML = ''; }, 300);
  }

  function abrir(handle) {
    if (!handle || cargando) return;
    cargando = true;
    var miTurno = ++turno;
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=tio-quickview-content')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        /* Si el cliente cerro mientras esto cargaba, la respuesta ya no
           corresponde: no se monta nada. Antes se abria igual, "resucitando"
           un panel que el cliente ya habia descartado. */
        if (miTurno !== turno) return;
        ov.innerHTML = html;
        abierto = true;
        ov.setAttribute('aria-hidden', 'false');

        /* ⚠️ 28-jul-2026. Aca se leia `ov.offsetWidth`, o sea el reflow se
           forzaba sobre el OVERLAY, no sobre el panel recien insertado. A
           veces el navegador no llegaba a fijar el estilo inicial del panel
           nuevo y la transicion de entrada no arrancaba: en movil el panel se
           quedaba con su translateY(100%) — fuera de la pantalla — mientras
           el velo si cubria todo. De ahi la sensacion de quedar atrapado.
           Ahora se mide el PANEL y se espera un fotograma antes de activarlo,
           que es la unica forma fiable de que la transicion corra siempre. */
        var panel = ov.querySelector('.qv');
        if (panel) void panel.offsetHeight;
        var activar = function () { ov.classList.add('is-active'); };
        if (window.requestAnimationFrame) {
          requestAnimationFrame(function () { requestAnimationFrame(activar); });
        } else {
          activar();
        }
        bloquearScroll(true);
      })
      .catch(function () {
        /* Si el Quick View no puede cargar, la venta NO se bloquea:
           se navega a la PDP, que siempre existe. */
        window.location.href = '/products/' + encodeURIComponent(handle);
      })
      .finally(function () { cargando = false; });
  }

  /* El popover de rendimiento se cierra solo al cerrar el Quick View, porque
     cerrar() vacia el innerHTML. Esto es para cerrarlo estando el QV abierto. */
  function cerrarAyuda() {
    var b = ov.querySelector('[data-tio-qv-ayuda]');
    if (!b || b.getAttribute('aria-expanded') !== 'true') return;
    b.setAttribute('aria-expanded', 'false');
    b.classList.remove('is-open');
    var g = ov.querySelector('#' + b.getAttribute('aria-controls'));
    if (g) g.classList.remove('is-open');
  }

  function variantePorDefecto() {
    var sel = ov.querySelector('[data-tio-qv-fmt].on');
    if (sel) return sel;
    return ov.querySelector('[data-tio-qv-fmt]:not([disabled])');
  }

  /* ---------------- Listeners delegados ---------------- */
  document.addEventListener('click', function (e) {
    /* 1. Abrir desde cualquier boton Agregar de card (regla F1) */
    var disparador = e.target.closest('[data-te-add]');
    if (disparador) {
      e.preventDefault();
      abrir(disparador.getAttribute('data-handle'));
      return;
    }

    /* 2. Cerrar: X, click en el scrim */
    if (e.target.closest('[data-tio-qv-close]')) { cerrar(); return; }
    if (abierto && e.target === ov) { cerrar(); return; }

    /* 2b. Popover "Rendimiento por formato" — espejo del de la PDP.
       Va aca arriba porque el boton vive dentro del modal y no debe caer
       en ninguna de las ramas de abajo. */
    var ayuda = e.target.closest('[data-tio-qv-ayuda]');
    if (ayuda) {
      var guia = ov.querySelector('#' + ayuda.getAttribute('aria-controls'));
      var yaAbierto = ayuda.getAttribute('aria-expanded') === 'true';
      ayuda.setAttribute('aria-expanded', yaAbierto ? 'false' : 'true');
      ayuda.classList.toggle('is-open', !yaAbierto);
      if (guia) guia.classList.toggle('is-open', !yaAbierto);
      return;
    }
    if (e.target.closest('[data-tio-qv-ayuda-cerrar]')) { cerrarAyuda(); return; }
    /* Click en cualquier otro sitio del modal: se cierra el popover y se
       DEJA SEGUIR el resto del handler, para no comerse ese click. */
    if (!e.target.closest('.teqv-fmt-guide')) cerrarAyuda();

    /* 3. Elegir formato */
    var fmt = e.target.closest('[data-tio-qv-fmt]');
    if (fmt && !fmt.disabled) {
      var todos = ov.querySelectorAll('[data-tio-qv-fmt]');
      for (var i = 0; i < todos.length; i++) {
        todos[i].classList.remove('on');
        todos[i].setAttribute('aria-pressed', 'false');
      }
      fmt.classList.add('on');
      fmt.setAttribute('aria-pressed', 'true');
      var precio = ov.querySelector('[data-tio-qv-precio]');
      if (precio) precio.textContent = fmt.getAttribute('data-precio');
      return;
    }

    /* 4. Confirmar el add: CADENA F3 */
    var add = e.target.closest('[data-tio-qv-add]');
    if (!add || add.disabled) return;

    var elegido = variantePorDefecto();
    if (!elegido) return;
    var variantId = elegido.getAttribute('data-variant-id');
    if (!variantId) return;

    /* ⚠️ CORREGIDO 28-jul-2026, mismo bug que la PDP: aca se hacia
       `add.disabled = true` y solo se soltaba 1200 ms DESPUES, dentro del
       .finally. El boton quedaba muerto mas de un segundo y el segundo click
       no hacia nada. El prototipo no deshabilita nunca. Ahora el guard es
       solo de CONCURRENCIA y se suelta al terminar la peticion. */
    if (add._tioEnviando) return;
    add._tioEnviando = true;

    /* FEEDBACK INMEDIATO — igual que la PDP y que el prototipo, que marca el
       boton antes de disparar el add. Una variante agotada no llega aca: nace
       deshabilitada. El CONTADOR sigue saliendo del item_count real. */
    if (add._tioReloj) clearTimeout(add._tioReloj);
    add.classList.remove('is-added');
    void add.offsetWidth;
    add.classList.add('is-added');
    /* 1600 ms, igual que la PDP. Antes eran 1200 y la coreografia del check
       termina a los 1080 (560 de retraso + 520 de la etiqueta): la
       confirmacion se borraba casi al instante de completarse. */
    add._tioReloj = setTimeout(function () {
      add.classList.remove('is-added');
      add._tioReloj = 0;
    }, 1600);

    /* (1) El add sale de inmediato. Si falla, el .catch retira el check. */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'No se pudo agregar'); });
        return r.json();
      })
      .then(function () {
        /* (2) El check ya se mostro al hacer click. Aca solo queda lo que
           DEBE salir del servidor: el contador real y el vuelo. */

        /* Contador con el item_count REAL, no incrementando a ciegas. */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (carrito) {
            /* (3) El vuelo es DECORACION y va con guard: si te-fly no
               existe o falla, onLand corre igual y el contador sube. */
            var safe = window.teFlySafe || function (el, onLand) { if (onLand) onLand(); };
            safe(add, function () {
              if (typeof window.tioActualizarCarrito === 'function') {
                window.tioActualizarCarrito(carrito.item_count);
              }
              document.dispatchEvent(new CustomEvent('tio:cart:updated', { detail: carrito }));
            });
            /* ⚠️ Eran 900 ms: el modal se cerraba ANTES de que terminara la
               coreografia del check (1080 ms), asi que la confirmacion no
               alcanzaba a verse. Se cierra despues, dejando un respiro para
               que el cliente vea que el producto entro. */
            setTimeout(cerrar, 1500);
          });
      })
      .catch(function (err) {
        /* Falló: se retira el check ya mostrado. */
        if (add._tioReloj) clearTimeout(add._tioReloj);
        add.classList.remove('is-added');
        console.error('[tio-quickview]', err);
      })
      .finally(function () {
        /* Se suelta al TERMINAR LA PETICION, no al terminar la animacion. */
        add._tioEnviando = false;
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  /* API publica: permite abrirlo desde cualquier superficie futura. */
  window.tioQuickView = { abrir: abrir, cerrar: cerrar };
})();
